import React from 'react'
import { PartnerProvider } from './partner'

/** @type {React.FC<IProps>}*/
export const Provider = ({ children }) => {
  return <PartnerProvider>{children}</PartnerProvider>
}
